import React from 'react';
import { Tabs } from '@statsbomb/kitbag-components';

import { useStore } from '../../../../store/useStore';
import { SCOUT_TABS } from '../ScoutResults.constants';
import { TabAdjuster, TabSequence, TabRoundel } from './ScoutTabs.styles';

export const ScoutTabs = () => {
  const scoutTabIndex = useStore((s) => s.scoutTabIndex);
  const setScoutTabIndex = useStore((s) => s.setScoutTabIndex);
  const selectedStats = useStore((s) => s.selectedStats);
  const selectedBiometrics = useStore((s) => s.selectedBiometrics);
  const showFavourites = useStore((s) => s.showFavourites);

  const selectedStatsLength = selectedStats?.length
    ? selectedStats.length - 1
    : 0;

  let generalCount = 2;
  if (
    selectedStats.find((m) => m.key === 'plays')?.value === 0 &&
    generalCount > 1
  ) {
    generalCount -= 1;
  }
  if (selectedBiometrics.find((b) => b.key === 'ncaaTransferPortal')?.value) {
    generalCount += 1;
  }
  if (showFavourites) {
    generalCount += 1;
  }

  const bioMetricsLength = selectedBiometrics.filter(
    (m) => m.key !== 'ncaaTransferPortal'
  ).length;

  return (
    <TabAdjuster
      $showTwo={bioMetricsLength > 0}
      $showThree={selectedStatsLength > 0}
    >
      <TabSequence
        $showThreeAlt={bioMetricsLength === 0 && selectedStatsLength > 0}
      >
        {generalCount > 0 && (
          <TabRoundel
            onClick={() => setScoutTabIndex(0)}
            id="general-tab-roundel"
          >
            {generalCount}
          </TabRoundel>
        )}
        {bioMetricsLength > 0 && (
          <TabRoundel
            onClick={() => setScoutTabIndex(1)}
            id="biometrics-tab-roundel"
          >
            {bioMetricsLength}
          </TabRoundel>
        )}
        {selectedStatsLength > 0 && (
          <TabRoundel
            onClick={() => setScoutTabIndex(2)}
            id="stats-tab-roundel"
          >
            {selectedStatsLength || 0}
          </TabRoundel>
        )}
      </TabSequence>
      <Tabs
        tabs={SCOUT_TABS}
        activeTab={scoutTabIndex}
        onTabChange={(e, tab) => {
          setScoutTabIndex(tab.value);
        }}
        testId="scout-results-tabs"
      />
    </TabAdjuster>
  );
};
